import { utils, directives } from './index';
import components from './src/components/pc';
export default {
    utils,
    directives,
    components
};
